import * as React from "react";

//false for light mode
//true for dark mode
export const dlModeContext = React.createContext();
